import React from "react";
import BaseKPIPage from "./BaseKPIPage";
import { KPI_PAGE_CONFIG } from "../constants/kpiConstants";
/**
 * KPI Page (Legacy/General)
 * Uses the reusable BaseKPIPage with speed stats configuration
 */
export default function SpeedStats() {
  return (
    <BaseKPIPage
      config={KPI_PAGE_CONFIG.speedStats}
      showInterval={false}
      showEndDate={true}
      showAggregation={true}
    />
  );
}